module.exports = __webpack_public_path__ + "static/media/pavel-kosov.496be5c6.jpg";